export default {
    RANKED: 1,
    UNRANKED: 2,
    ALL: 3,
    NON_VALIDATED: 4,
    VALIDATED: 5,
}